export abstract class AbstractActions implements AltJS.ActionsClass {
    constructor(alt: AltJS.Alt) {
    }

    actions: any;
    dispatch: (...payload: Array<any>) => void;
    generateActions: (...actions: Array<string>) => void;
}



// WEBPACK FOOTER //
// ./src/app/actions/AbstractActions.ts